<template>
<Dialog
    ref="dialog"
    width="480px"
    :class="bem()"
    :onOk="onOk"
    :onCancel="onCancel"
    :showClose="false"
    okText="重新登录"
    cancelText="关闭"
    title="下线通知"
    centered
>
    <div :class="bem('wrapper')">
        <div :class="bem('tips')">
            你的账号在另外一台设备登录，你将被迫下线，如果这不是你本人的操作，那么你的密码可能已经泄露了，建议修改密码。
        </div>
        <div :class="bem('info')">
            <span>
                登录时间:
            </span>
            <span>
                {{ login_at }}
            </span>
        </div>
        <div :class="bem('info')">
            <span>
                登录设备:
            </span>
            <span>
                {{ deviceName }}
            </span>
        </div>
    </div>
</Dialog>

</template>
<script>
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import _Dialog from '@gaoding/gdui/lib/dialog';
import bemMixin from '../bem';
export default _Dialog.create({
  name: 'scramble-dialog',
  components: {
    Dialog: _Dialog
  },
  props: {
    // 显示弹窗 支持 :visible.sync
    visible: {
      type: Boolean,
      default: false
    },
    onOk: {
      type: Function
    },
    onCancel: {
      type: Function
    },
    afterClose: {
      type: Function
    },
    // 是否显示关闭按钮
    showClose: {
      type: Boolean,
      default: true
    },
    // 点击遮罩是否可关闭
    maskClosable: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      // offline / danger
      default: 'offline'
    },
    // 抢登时间
    login_at: {
      type: String,
      default: ''
    },
    // 抢登设备
    os: {
      type: String,
      default: '未知设备'
    }
  },
  mixins: [bemMixin],
  computed: {
    deviceName: function deviceName() {
      var os = this.os || 'unknown';
      return os.trim() === 'unknown' ? '未知设备' : os;
    }
  }
});
</script>
<style>































































































.scramble-dialog__wrapper {
    color: #636c78;
    font-family: PingFang SC;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
}
.scramble-dialog__tips {
    margin-bottom: 20px;
}

</style>
